/**
 * 日常点検ページ用のスクリプト
 */
if (is_route('daily_check.index')) {
    // 変更検知用カウント
    var _vcCount = 0;
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        daily_check_event_set();
        daily_check_setting_event_set();
        daily_check_item_status_change_event_set();
        daily_check_modal_close_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.daily_check_event_set = function () {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function (e) {
        let old = $(this).data('old');
        _modal.create(this, 'setting-modal', ['id', 'date', 'user_id', 'vehicle_id', 'company_id', 'api_flag'], true, function (e) {
            $('select[name="vehicle_id"]').data('old', old);

            const $modal = $('#daily_check-setting-modal');
            $modal.one('shown.bs.modal', function () {
                const $company = $modal.find('select.company-select');
                if (!$company.val()) return;

                setSelect($company[0], $modal.find('select[name="user_id"]'));
            });
        });
    });

    /*---- 詳細表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-detail-modal]', function (e) {
        _modal.create(this, 'detail-modal', ['id', 'date', 'user_id', 'vehicle_id']);
    });

    /*---- 保存時 ----*/

    // 保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
        });
    });

    /*---- 印刷時 ----*/

    $(document).on('click', '[data-print]', function (e) {
        // バブリング停止
        e.stopPropagation();
        let action = $(this).data('print');
        // データを追加
        let datas = {'id': $(this).data('daily_check_id')};
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // リロード：表示時
    $(document).on('click', '[data-reload-modal]', function () {
        let select = $('select[name="vehicle_id"]');

        // 空→設定の場合、点検項目を再読み込み
        // if (!select.data('old')) {
        //     $('[data-execute-modal]').trigger('click');
        // }
        let old = select.data('old');
        _modal.create_with_data(this, 'reload-modal', {
            'id': $(this).data('id'),
            'old_vehicle_id': select.data('old'),
            'new_vehicle_id': select.val()
        }, false, function () {
            select.data('old', old);
        },'action', false);
    });

    // リロード実行時
    $(document).on('click', '[data-execute-modal]', function () {
        // 編集の場合、法定項目を切り替えたい
        if ($('#daily_check-setting-modal-id').val()) {
            load_check_items('custom');
        // 新規の場合、法定・カスタム項目を両方とも切り替える
        } else {
            load_check_items('legal');
            load_check_items('custom');
        }
        _vcCount = 1;
        _modal.hide($(this).data('execute-modal'));
    });

    // リロード：戻る時
    $(document).on('click', '[data-dismiss="modal"]', function () {
        if ($(this).closest('#daily_check-reload-modal').length) {
            const select = $('select[name="vehicle_id"]');
            const oldVal = select.data('old');
            if (select.val() !== oldVal) {
                select
                    .data('programmatic-change', false)
                    .val(oldVal)
                    .trigger('change');
            }
        }
        _vcCount = 1;
    });
}

/**
 * 点検項目を読み込む (法定・カスタム)
 */
window.load_check_items = function(type, phase = null) {
    const isLegal = type === 'legal';
    const targetList = isLegal ? '#daily-check-item-list' : '#daily-check-custom-item-list';
    const noItemsId = isLegal ? '#no-check-items' : '#no-check-custom-items';
    
    if (type === null) {
        $('#daily-check-item-list, #daily-check-custom-item-list').html('');
        $('#no-check-items, #no-check-custom-items').show();
        return;
    }

    $(targetList).html('');
    $(noItemsId).show().removeClass('d-none');

    // 初回では、確認モーダルではなく車両欄からURLを取得
    let url = null;
    if (phase === null) {
        url = $('#daily_check-reload-modal-form').attr('action');
    } else if (phase === "initial") {
        url = $('#daily_check-setting-modal-vehicle_id').data('check_items');
    }

    let select = $('select[name="vehicle_id"]');
    let newVal = select.val();
    let oldVal = select.data('old');

    let data = {
        'old_vehicle_id': oldVal, 
        'new_vehicle_id': newVal, 
        'id': $('#daily_check-setting-modal-id').val(), 
        'content_id': 'daily_check-setting-modal', 
        'type': type
    };

    _ajax.post(url, data, function(results) {
        if (results.length > 0) {
            $(targetList).html(results);
            $(noItemsId).hide().addClass('d-none');

            // 点検項目切り替えイベント - set radio value to 1
            let _sSwith = $('.master-switch input[type="radio"][value="1"]');
            if (_sSwith) {
                _sSwith.prop('checked', true);
                $('.master-switch label').removeClass('active');
                _sSwith.closest('label').addClass('active');
                _sSwith.trigger('change');
            }
        }
    }, function(xhr, status, errorThrown){
        _error.omitted(xhr, status, errorThrown);
    }, 'html');
}

/**
 * 日常点検設定モーダル表示時のイベント設定
 */
window.daily_check_setting_event_set = function ()
{
    const selector = 'select[name="vehicle_id"]';

    // 会社選択時、カウントをリセット
    $(document).on('change', 'select[name="company_id"]', function (e) {
        _vcCount = 1;
        $('select[name="vehicle_id"]').data('old', '');
        $('select[name="vehicle_id"]').data('programmatic-change', true);
    });

    /*---- 旧値保存 ----*/
    $(document)
        .off('select2:opening.daily_check_setting')
        .on ('select2:opening.daily_check_setting', selector, function () {
            $(this).data('old', $(this).val());
        });

    /*---- 変更検知 ----*/
    $(document)
        .off('change.daily_check_setting')
        .on ('change.daily_check_setting', selector, function () {

            // 点検項目が存在しない場合
            const is_initial = $('.daily_check-setting-modal-switch-row').length === 0;

            const oldVal = $(this).data('old');
            const newVal = $(this).val();

            if ($(this).data('programmatic-change')) {
                $(this).removeData('programmatic-change');
                if (!is_initial) return;
            }

            // 空の場合はカウントをリセット
            if (newVal === '') {
                _vcCount = 1;
                return;
            };

            let mid  = $('#daily_check-setting-modal-id').val();

            // --------------------------start
            _vcCount++;

            let apiFlg = $('#daily_check-setting-modal-api_flag').val();
            console.log('apiFlg: ' + apiFlg + '; _vcCount: ' + _vcCount);

            if (_vcCount > 2) {
                _vcCount = 1;
                return;
            }

            // if (newVal === '') load_check_items(null);

            if (!newVal || oldVal === newVal) return;
        
            // 点検項目が存在しない場合、確認モーダルを表示せず直接点検項目を描写する
            if (is_initial) {
                load_check_items('legal', 'initial');
                load_check_items('custom', 'initial');
                _vcCount = 1;
            } else {
                // 点検項目が存在する場合、確認モーダルを表示する
                let chk  = $(this).data('check');
                _ajax.post(chk,
                    { old_vehicle_id: oldVal, new_vehicle_id: newVal, id: mid },
                    results => {
                        if (results.section_changed) {
                            $('[data-reload-modal="#daily_check-reload-modal"]').trigger('click');
                        }
                        _vcCount = 1;
                    },
                    (xhr, status, err) => {
                        _error.omitted(xhr, status, err);
                        _vcCount = 1;
                    }
                );
            }
        });

    // 点検項目削除ボタン押下時
    $(document).on('click', '.delete-check_item', function () {
        $(this).closest('.check_item').remove();

        var $container = $('#customTab');
        var customItemsCount = $container.find('.check_item').length;
        if(customItemsCount <= 0) {
            $('#no-check-custom-items').removeClass('d-none').show();
        } else {
            $('#no-check-custom-items').addClass('d-none').hide();
        }
    });
}

/**
 * 日常点検選択モーダル表示時のイベント設定
 * @param {*} selectedCallBack 選択ボタン押下時のコールバック関数
 */
window.daily_check_select_event_set = function (selectedCallBack) {

    let modalId = '#daily_check-select-modal';
    
    // 選択ボタン押下時
    $(document).on('click', '.daily_check-select-table .btn-select', function (e) {
        // 呼び出し元画面に戻り値を設定する
        selectedCallBack($(this).data('id'));
        // モーダルを閉じる
        _modal.hide(modalId);
    });

}


/**
 * 点検項目が切り替え時のイベント設定
 */
window.daily_check_item_status_change_event_set = function ()
{
    $(document).on('change', '.master-switch input[type="radio"]', function (e) {
        const value = $(this).val();

        if (value === '1') {
            // Show only status = 1, hide status = 2
            $('div[data-status="1"]').show();
            $('div[data-status="2"]').hide();
        } else {
            // Show all statuses
            $('div[data-status="1"], div[data-status="2"]').show();
        }
    });
}

/**
 * モーダル閉じるイベントの設定
 */
window.daily_check_modal_close_event_set = function() {
    
    // 設定モーダル閉じる時
    $(document).on('hidden.bs.modal', '#daily_check-setting-modal', function () {
        _vcCount = 0;

        const selector = 'select[name="vehicle_id"]';
        $(selector).removeData('old');
        $(selector).val('');
    });
}
